import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "email-symbol",
  "use": "email-symbol-usage",
  "viewBox": "0 0 22 22",
  "content": "<symbol fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 22 22\" id=\"email-symbol\"><path clip-rule=\"evenodd\" d=\"M15.375 11a4.375 4.375 0 11-8.75 0 4.375 4.375 0 018.75 0z\" stroke=\"currentColor\" stroke-width=\"1.5\" stroke-linecap=\"round\" stroke-linejoin=\"round\" /><path d=\"M15.375 11v1.875a2.5 2.5 0 005 0V11a9.374 9.374 0 10-3.75 7.5\" stroke=\"currentColor\" stroke-width=\"1.5\" stroke-linecap=\"round\" stroke-linejoin=\"round\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/img/svg/email-symbol.svg
// module id = Uu+4
// module chunks = 39 44